<template>
  <v-container
    fluid
    grid-list-xl
  >
    <app-mapeamento
      :acesso="acesso"
      :fim="fimPeriodo"
      :inicio="inicioPeriodo"
      :titulo="tituloPagina"
    >
      <template v-slot:body>
        <v-col
          v-if="prazoAtual || prazoEsgotado"
          centered
          cols="12"
          no-gutters
        >
          <v-tabs
            v-model="categoria"
            centered
            icons-and-text
          >
            <v-tabs-slider color="secondary" />
            <v-tab
              v-for="i in categorias.length"
              :key="i"
              :href="'#' + categorias[i - 1].id"
              class="mt-3"
            >
              <span class="grey--text text--darken-2">{{
                categorias[i - 1].descricao
              }}</span>
              <v-icon
                :color="
                  categorias[i - 1].id === categoria ? 'secondary' : 'grey'
                "
                class="mb-2"
              >
                {{ categorias[i - 1].icone }}
              </v-icon>
            </v-tab>
          </v-tabs>
          <v-tabs-items v-model="categoria">
            <v-tab-item value="responsabilidades">
              <v-row no-gutters>
                <v-col>
                  <v-row dense>
                    <v-toolbar flat>
                      <v-toolbar-title>
                        <h2
                          class="
                            title
                            primary--text
                            text--darken-1 text-no-wrap
                            mt-0
                          "
                        >
                          FILTROS
                        </h2>
                      </v-toolbar-title>
                    </v-toolbar>
                  </v-row>
                  <v-row>
                    <v-autocomplete
                      v-model="filtros.unidades"
                      :item-text="getUnidadeSiglaAndNome"
                      :items="unidades"
                      :search-input.sync="pesquisaUnidade"
                      class="mx-2"
                      label="Unidade(s):"
                      placeholder="Digite para pesquisar..."
                      multiple
                      prepend-icon="account_balance"
                      return-object
                      @change="pesquisaUnidade = ''"
                      @input="loadResponsabilidades"
                    >
                      <template
                        v-if="unidades.length > 0"
                        v-slot:prepend-item
                      >
                        <v-list-item @click="toggleItens">
                          <v-list-item-action>
                            <v-icon
                              :color="
                                filtros.unidades.length > 0 ? 'primary' : ''
                              "
                            >
                              {{ icon }}
                            </v-icon>
                          </v-list-item-action>
                          <v-list-item-content>
                            <v-list-item-title>
                              Selecionar Todas
                            </v-list-item-title>
                          </v-list-item-content>
                        </v-list-item>
                        <v-divider class="mt-2" />
                      </template>
                      <template v-slot:selection="data">
                        <v-chip
                          :input-value="data.selected"
                          class="chip--select-multi"
                          close
                          color="primary"
                          search=""
                          small
                          text-color="white"
                          @click:close="removeUnidade(data.item)"
                        >
                          {{ data.item.sigla }}
                        </v-chip>
                      </template>
                    </v-autocomplete>
                  </v-row>
                  <v-row>
                    <v-col
                      cols="12"
                      md="4"
                    >
                      <v-row no-gutters>
                        <v-select
                          v-model="filtros.situacao"
                          :items="situacoes"
                          class="mr-4"
                          item-text="descricao"
                          item-value="id"
                          label="Situação:"
                          prepend-icon="filter_list"
                          @input="loadResponsabilidades"
                        />
                      </v-row>
                    </v-col>
                    <v-col
                      cols="12"
                      md="4"
                    >
                      <v-row no-gutters>
                        <app-sort v-model="opcoes" />
                      </v-row>
                    </v-col>
                    <v-col
                      cols="12"
                      md="4"
                    >
                      <app-search v-model="opcoes" />
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-toolbar flat>
                      <v-toolbar-title>
                        <h2
                          class="
                            title
                            primary--text
                            text--darken-1 text-no-wrap
                            mb-4
                          "
                        >
                          RESPONSABILIDADES ({{ responsabilidades.length }})
                        </h2>
                      </v-toolbar-title>
                    </v-toolbar>
                  </v-row>
                </v-col>
              </v-row>
              <v-row no-gutters>
                <v-col>
                  <v-data-table
                    v-model="selectedResponsabilidades"
                    :headers="headers"
                    :items="responsabilidades"
                    :search="opcoes.pesquisa"
                    :sort-by="opcoes.ordenarPor"
                    :sort-desc="opcoes.decrescente"
                    class="elevation-0"
                    item-key="id"
                    show-expand
                    show-select
                    single-expand
                  >
                    <template
                      v-slot:[`header.data-table-select`]="{ on, props }"
                    >
                      <v-simple-checkbox
                        v-show="responsabilidades.length > 0 && prazoAtual"
                        :disabled="
                          filtros.situacao === 'CONSOLIDADAS' ||
                            filtros.situacao === 'EXCLUIDAS'
                        "
                        color="primary"
                        v-bind="props"
                        @input="toggleAllCheckboxes"
                        v-on="on"
                      />
                    </template>
                    <template
                      v-slot:[`item.data-table-select`]="{
                        isSelected,
                        select,
                        item,
                      }"
                    >
                      <v-simple-checkbox
                        v-show="prazoAtual"
                        v-ripple
                        :disabled="
                          (tipoNormalizacao === 'consolidacao' &&
                            item.consolidada) ||
                            (tipoNormalizacao === 'normalizacao' &&
                              item.normalizada) ||
                            item.excluida
                        "
                        :value="isSelected"
                        color="primary"
                        @input="select($event)"
                      />
                    </template>
                    <template v-slot:[`item.status`]="{ item }">
                      <v-col>
                        <v-chip
                          v-show="item.normalizada"
                          class="mb-2"
                          color="secondary"
                          outlined
                          small
                        >
                          Normalizada
                        </v-chip>
                        <v-chip
                          v-show="item.validada"
                          class="mb-2"
                          color="purple lighten-2"
                          outlined
                          small
                        >
                          Validada
                        </v-chip>
                        <v-chip
                          v-show="item.consolidada"
                          class="mb-2"
                          color="success"
                          outlined
                          small
                        >
                          Consolidada
                        </v-chip>
                        <v-chip
                          v-show="item.excluida"
                          class="mb-2"
                          color="error"
                          outlined
                          small
                        >
                          Arquivada
                        </v-chip>
                      </v-col>
                    </template>
                    <template
                      v-slot:[`item.data-table-expand`]="{
                        item,
                        expand,
                        isExpanded,
                      }"
                    >
                      <v-tooltip top>
                        <template v-slot:activator="{ on }">
                          <v-btn
                            height="100%"
                            text
                            width="100%"
                            @click="expand(!isExpanded)"
                            v-on="on"
                          >
                            <v-badge right>
                              <template v-slot:badge>
                                <span>{{
                                  item.competenciasAtuais.length
                                }}</span>
                              </template>
                              <v-icon
                                color="grey lighten-0"
                                large
                              >
                                build
                              </v-icon>
                            </v-badge>
                          </v-btn>
                        </template>
                        <span>Clique para exibir as competências técnicas</span>
                      </v-tooltip>
                    </template>
                    <template v-slot:expanded-item="{ headers, item }">
                      <td
                        :colspan="headers.length"
                        class="justify-center"
                      >
                        <v-row>
                          <v-spacer />
                          <v-col>
                            <v-row class="justify-center">
                              <h2
                                class="
                                  title
                                  primary--text
                                  text--darken-1 text-no-wrap
                                "
                              >
                                COMPETÊNCIAS TÉCNICAS
                              </h2>
                            </v-row>
                          </v-col>
                          <v-spacer />
                        </v-row>
                        <v-row>
                          <v-spacer />
                          <v-col cols="10">
                            <v-simple-table
                              class="elevation-0 mb-4"
                              dense
                            >
                              <template v-slot:default>
                                <tbody>
                                  <tr
                                    v-for="column in item.colunasCompetencias.lista"
                                    :key="column.id"
                                  >
                                    <td
                                      v-for="item in column"
                                      :key="item.id"
                                      width="30%"
                                    >
                                      <div class="d-flex flex-row ma-1">
                                        <span
                                          v-if="item.unidades.length === 0"
                                          class="secondary--text"
                                        >
                                          {{ item.nomeAtual }}
                                        </span>
                                        <span
                                          v-if="item.unidades.length > 0"
                                          class="grey-text text--darken-2"
                                        >
                                          {{ item.nomeAtual }}
                                        </span>
                                      </div>
                                    </td>
                                  </tr>
                                </tbody>
                              </template>
                            </v-simple-table>
                          </v-col>
                          <v-spacer />
                        </v-row>
                        <v-spacer />
                      </td>
                    </template>
                    <template v-slot:[`item.tipo`]="{ item }">
                      <v-col>
                        <v-tooltip
                          max-width="500"
                          top
                        >
                          <template v-slot:activator="{ on }">
                            <v-chip
                              class="ml-1"
                              color="success white--text"
                              label
                              small
                              v-on="on"
                            >
                              Dificuldade
                              {{ item.dificuldadeAtual.valor }}
                            </v-chip>
                          </template>
                          <span>{{ item.dificuldadeAtual.descricao }}</span>
                        </v-tooltip>
                        <v-tooltip
                          max-width="500"
                          top
                        >
                          <template v-slot:activator="{ on }">
                            <v-chip
                              class="ml-1"
                              color="secondary white--text"
                              label
                              small
                              v-on="on"
                            >
                              Impacto
                              {{ item.impactoAtual.valor }}
                            </v-chip>
                          </template>
                          <span>{{ item.impactoAtual.descricao }}</span>
                        </v-tooltip>
                      </v-col>
                    </template>
                    <template v-slot:[`item.acoes`]="{ item }">
                      <v-col>
                        <v-tooltip top>
                          <template v-slot:activator="{ on }">
                            <v-btn
                              v-show="item.isEditarBtnDisponivel"
                              class="mr-2"
                              color="secondary"
                              icon
                              small
                              @click="editItem(item)"
                              v-on="on"
                            >
                              <v-icon>edit</v-icon>
                            </v-btn>
                          </template>
                          <span>Clique no botão para editar a
                            responsabilidade</span>
                        </v-tooltip>
                        <v-tooltip top>
                          <template v-slot:activator="{ on }">
                            <v-btn
                              v-show="item.isArquivarBtnDisponivel"
                              class="mr-2"
                              color="error"
                              icon
                              small
                              @click="confirmDeleteItem(item)"
                              v-on="on"
                            >
                              <v-icon>archive</v-icon>
                            </v-btn>
                          </template>
                          <span>Clique no botão para arquivar a
                            responsabilidade</span>
                        </v-tooltip>

                        <v-tooltip top>
                          <template v-slot:activator="{ on }">
                            <v-btn
                              v-show="item.isDesfazerBtnDisponivel"
                              :color="colorBtnDesfazer"
                              class="mr-2"
                              icon
                              small
                              @click="desfazer(item)"
                              v-on="on"
                            >
                              <v-icon>settings_backup_restore</v-icon>
                            </v-btn>
                          </template>
                          <span>Clique no botão para cancelar a {{ nomeAcao }} da
                            responsabilidade</span>
                        </v-tooltip>

                        <v-tooltip top>
                          <template v-slot:activator="{ on }">
                            <v-btn
                              v-show="item.excluida && prazoAtual"
                              class="mr-2"
                              color="error"
                              icon
                              small
                              @click="restaurarItem(item)"
                              v-on="on"
                            >
                              <v-icon>settings_backup_restore</v-icon>
                            </v-btn>
                          </template>
                          <span>Clique no botão para restaurar a
                            responsabilidade</span>
                        </v-tooltip>

                        <v-tooltip top>
                          <template v-slot:activator="{ on }">
                            <v-btn
                              v-show="item.isLupaBtnDisponivel"
                              color="grey"
                              icon
                              small
                              @click="visualizarItem(item)"
                              v-on="on"
                            >
                              <v-icon color="grey lighten-0">
                                search
                              </v-icon>
                            </v-btn>
                          </template>
                          <span>Clique no botão para visualizar o histórico de
                            edições da responsabilidade</span>
                        </v-tooltip>
                      </v-col>
                    </template>
                  </v-data-table>
                </v-col>
              </v-row>
            </v-tab-item>
            <v-tab-item value="competencias">
              <v-row>
                <gerenciamento-competencias
                  v-model="competenciasSelecionadas"
                  :etapa="tipoNormalizacao"
                  :mapeamento="mapeamento"
                  :unidades="unidades"
                  :prazo-atual="prazoAtual"
                />
              </v-row>
            </v-tab-item>
          </v-tabs-items>
          <v-row class="justify-end mb-1">
            <v-tooltip
              v-if="categoria === 'responsabilidades'"
              max-width="400"
              top
            >
              <template v-slot:activator="{ on }">
                <v-btn
                  :disabled="responsabilidades.length === 0"
                  class="mr-2"
                  color="success"
                  @click="generateWorksheet()"
                  v-on="on"
                >
                  <v-icon>get_app</v-icon>
                  BAIXAR XLS
                </v-btn>
              </template>
              <span>Clique para baixar os dados em formato XLS.</span>
            </v-tooltip>
          </v-row>
        </v-col>
      </template>
      <template v-slot:actions>
        <v-row no-gutters>
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-btn
                v-show="prazoAtual && categoria === 'responsabilidades'"
                class="mr-2"
                color="secondary"
                outlined
                @click="categoria = 'competencias'"
                v-on="on"
              >
                <v-icon class="mr-2">
                  keyboard_arrow_left
                </v-icon>
                ANTERIOR
              </v-btn>
            </template>
            <span>Clique no botão para voltar para a normalização das
              competências.</span>
          </v-tooltip>
          <!-- agrupar -->
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-btn
                v-show="prazoAtual && categoria === 'competencias'"
                :disabled="competenciasSelecionadas.length < 2"
                class="mr-2"
                color="primary"
                @click="toggleAgruparCompetenciasSelecionadas"
                v-on="on"
              >
                AGRUPAR
                <v-icon class="ml-2">
                  folder_copy
                </v-icon>
              </v-btn>
            </template>
            <span>Clique no botão para voltar para agrupar as competências
              selecionadas.</span>
          </v-tooltip>

          <v-tooltip
            v-if="prazoAtual"
            :disabled="selectedResponsabilidades.length === 0"
            top
          >
            <template v-slot:activator="{ on }">
              <v-btn
                v-show="prazoAtual && categoria === 'responsabilidades'"
                :disabled="selectedResponsabilidades.length === 0"
                class="mr-2"
                color="primary"
                @click="consolidar"
                v-on="on"
              >
                {{ nomeBtnOperacao }}
                <v-icon class="ml-2">
                  folder_copy
                </v-icon>
              </v-btn>
            </template>
            <span>Clique no botão para {{ nomeBtnOperacao.toLowerCase() }} a(s)
              responsabilidade(s)</span>
          </v-tooltip>
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-btn
                v-show="prazoAtual && categoria === 'responsabilidades'"
                :disabled="responsabilidades.length === 0"
                color="secondary"
                outlined
                @click="toggleDialogAgradecimento"
                v-on="on"
              >
                FINALIZAR
                <v-icon class="ml-2">
                  check
                </v-icon>
              </v-btn>
            </template>
            <span>Clique no botão para finalizar a normalização das
              responsabilidades</span>
          </v-tooltip>
          <v-tooltip top>
            <template v-slot:activator="{ on }">
              <v-btn
                v-show="prazoAtual && categoria === 'competencias'"
                color="secondary"
                outlined
                @click="categoria = 'responsabilidades'"
                v-on="on"
              >
                PRÓXIMO
                <v-icon class="ml-2">
                  keyboard_arrow_right
                </v-icon>
              </v-btn>
            </template>
            <span>Clique no botão para seguir para a normalização das
              responsabilidades.</span>
          </v-tooltip>
        </v-row>
      </template>
    </app-mapeamento>

    <v-dialog
      v-model="dialogs.dialogRemove.visible"
      max-width="370"
      persistent
    >
      <v-card>
        <v-card-title class="headline" />
        <v-card-text>
          Você realmente deseja arquivar essa responsabilidade?
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="error"
            text
            @click="deleteItem"
          >
            Arquivar
          </v-btn>
          <v-btn
            color="grey"
            text
            @click="toggleDialogRemove"
          >
            Cancelar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <edicao-responsabilidade
      v-if="dialogs.dialogEdit.visibilidade"
      :etapa="tipoNormalizacao"
      :responsabilidade="dialogs.dialogEdit.item"
      :dialog="dialogs.dialogEdit"
      @updated="isUpdated"
    />

    <historico-responsabilidade
      v-if="dialogs.dialogHistorico.visibilidade"
      :responsabilidade="dialogs.dialogHistorico.item"
      :etapa="tipoNormalizacao"
      :dialog="dialogs.dialogHistorico"
    />

    <dialog-agradecimento
      :dialog-visible="dialogs.dialogAgradecimento.visible"
      :toogle-visible="toggleDialogAgradecimento"
      :descricao="
        'Agradecemos pela sua colaboração! Você ainda poderá participar da ' +
          nomeAcao +
          ' das responsabilidades até o período estabelecido.'
      "
      url-redirecionamento="/gerenciamento"
    />

    <v-dialog
      v-model="agruparCompetenciasSelecionadasDialog"
      max-width="600"
      persistent
    >
      <v-form
        ref="form"
        lazy-validation
        @submit.prevent="agruparCompetenciasSelecionadas"
      >
        <v-card class="pa-4">
          <v-card-title class="headline primary--text text-no-wrap">
            Insira o novo nome para as competências abaixo:
          </v-card-title>
          <v-card-text>
            <v-chip
              v-for="competencia in competenciasSelecionadasOrdenadas"
              :key="competencia.id"
              class="mb-1 ml-1"
              color="grey"
              small
              text-color="white"
            >
              {{ competencia.nomeAtual }}
            </v-chip>
            <v-text-field
              v-model.trim="nomeCompetenciaAgrupadora"
              hint="Insira um nome que represente todas as competências a serem agrupadas"
              label="Nome da competência agrupadora"
            />
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn
              :disabled="nomeCompetenciaAgrupadora.trim().length === 0"
              color="primary"
              type="submit"
            >
              Agrupar
            </v-btn>
            <v-btn
              color="primary"
              outlined
              @click="toggleAgruparCompetenciasSelecionadas"
            >
              Cancelar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
  </v-container>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import { generateXLS } from '@/modules/relatorioPlanilha';
import AppSort from '@/components/core/AppSort';
import AppSearch from '@/components/core/AppSearch';
import HistoricoResponsabilidade from '@/components/mapeamento/HistoricoResponsabilidade';
import EdicaoResponsabilidade from '@/components/mapeamento/EdicaoResponsabilidade';
import GerenciamentoCompetencias from '@/views/mapeamento/responsabilidade/GerenciamentoCompetenciasTecnicas';
import DialogAgradecimento from '@/components/DialogAgradecimento';
import AppMapeamento from '@/components/core/AppMapeamento';
import { RepositoryFactory } from '@/repositories/RepositoryFactory';
import Data from '@/modules/data';

const responsabilidadeRepository = RepositoryFactory.get('responsabilidade');
const competenciaTecnicaRepository = RepositoryFactory.get('competenciaTecnica');

export default {
  components: {
    AppSort,
    AppSearch,
    HistoricoResponsabilidade,
    EdicaoResponsabilidade,
    GerenciamentoCompetencias,
    DialogAgradecimento,
    AppMapeamento,
  },

  data() {
    return {
      pesquisaUnidade: '',
      selectedResponsabilidades: [],
      dialogs: {
        dialogEdit: {
          titulo: 'Editar Responsabilidade',
          visibilidade: false,
          actions: true,
          item: null,
        },
        dialogRemove: { visible: false, item: null },
        dialogHistorico: {
          titulo: 'Histórico de Alterações da Responsabilidade',
          visibilidade: false,
          fullscreen: true,
          item: null,
        },
        dialogAgradecimento: { visible: false },
      },
      situacoes: [],
      filtros: {
        unidades: [],
        situacao: 'TODAS',
      },
      headers: [],
      opcoes: {
        pesquisa: '',
        decrescente: false,
        ordenarPor: 'tituloAtual',
        selecionado: { id: 'tituloAtual', descricao: 'Responsabilidade' },
        lista: [
          { id: 'dificuldadeAtual.valor', descricao: 'Grau de Dificuldade' },
          { id: 'impactoAtual.valor', descricao: 'Grau de Impacto' },
          { id: 'tituloAtual', descricao: 'Responsabilidade' },
          { id: 'competenciasAtuais.length', descricao: 'Número de Competências' },
          { id: 'unidade.sigla', descricao: 'Unidade' },
        ],
      },
      acesso: 'COMISSAO',
      inicioPeriodo: '',
      competenciasSelecionadas: [],
      fimPeriodo: '',
      tituloPagina: '',
      categoria: '',
      categorias: [
        {
          id: 'competencias',
          descricao: 'Competências',
          icone: 'build',
        },
        {
          id: 'responsabilidades',
          descricao: 'Responsabilidades',
          icone: 'settings',
        },
      ],
      agruparCompetenciasSelecionadasDialog: false,
      nomeCompetenciaAgrupadora: '',
    };
  },

  computed: {
    ...mapState({
      comissao: (state) => state.auth.comissao,
      mapeamento: (state) => state.mapeamento.mapeamentoComissao,
      competenciasTecnicas: (state) => state.competencia.competenciasTecnicas,
    }),
    tipoNormalizacao() {
      switch (this.$router.history.current.name) {
        case 'NormalizacaoResponsabilidade':
          return 'normalizacao';
        case 'ConsolidacaoResponsabilidade':
          return 'consolidacao';
        default:
          return '';
      }
    },
    competenciasSelecionadasOrdenadas() {
      return this.competenciasSelecionadas.slice().sort((a, b) => a.nomeAtual.localeCompare(b.nomeAtual));
    },
    colorBtnDesfazer() {
      if (this.tipoNormalizacao === 'normalizacao') {
        return 'secondary';
      }
      if (this.tipoNormalizacao === 'consolidacao') {
        return 'success';
      }
      return null;
    },
    nomeAcao() {
      return (
        (this.tipoNormalizacao === 'normalizacao' && 'normalização')
        || (this.tipoNormalizacao === 'consolidacao' && 'consolidação')
      );
    },
    nomeBtnOperacao() {
      return (
        (this.tipoNormalizacao === 'normalizacao' && 'NORMALIZAR')
        || (this.tipoNormalizacao === 'consolidacao' && 'CONSOLIDAR')
      );
    },
    isTutorialExibido: {
      get() {
        switch (this.tipoNormalizacao) {
          case 'normalizacao':
            return this.$store.state.tutorial.dados.normalizacaoResponsabilidade;
          case 'consolidacao':
            return this.$store.state.tutorial.dados.consolidacaoResponsabilidade;
          default:
            return true;
        }
      },
    },
    unidades() {
      const unidades = [this.mapeamento.unidade, ...this.mapeamento.unidades];
      return unidades.sort((a, b) => {
        if (a.sigla < b.sigla) {
          return -1;
        }
        if (a.sigla > b.sigla) {
          return 1;
        }
        return 0;
      });
    },
    responsabilidadesArmazenadas: {
      get() {
        return this.$store.state.responsabilidade.responsabilidades;
      },
      set(responsabilidades) {
        this.$store.dispatch('responsabilidade/setResponsabilidades', responsabilidades);
      },
    },
    responsabilidades() {
      switch (this.tipoNormalizacao) {
        case 'normalizacao':
          return this.responsabilidadesArmazenadas
            .filter(
              (r) => this.filtros.unidades.some((u) => u.idVersao === r.unidade.id)
                && (this.filtros.situacao === 'TODAS'
                  || (this.filtros.situacao === 'ARQUIVADAS' && r.excluida)
                  || (this.filtros.situacao === 'NORMALIZADAS' && r.normalizada)
                  || (this.filtros.situacao === 'NAO_NORMALIZADAS' && !r.normalizada)),
            )
            .map((r) => ({
              ...r,
              isEditarBtnDisponivel: !r.excluida && this.prazoAtual && !r.normalizada,
              isArquivarBtnDisponivel: !r.excluida && this.prazoAtual && !r.normalizada,
              isDesfazerBtnDisponivel: !r.excluida && this.prazoAtual && r.normalizada,
              isLupaBtnDisponivel: !r.excluida && !this.prazoFuturo && r.normalizada,
              colunasCompetencias: this.gerarColunas(r.competenciasAtuais),
            }));
        case 'consolidacao':
          return this.responsabilidadesArmazenadas
            .filter(
              (r) => this.filtros.unidades.some((u) => u.id === r.unidade.unidade.id)
                && (this.filtros.situacao === 'TODAS'
                  || (this.filtros.situacao === 'VALIDADAS' && r.validada)
                  || (this.filtros.situacao === 'CONSOLIDADAS' && r.consolidada)
                  || (this.filtros.situacao === 'NAO_CONSOLIDADAS' && !r.consolidada)
                  || (this.filtros.situacao === 'ARQUIVADAS' && r.excluida)
                  || (this.filtros.situacao === 'NAO_VALIDADAS' && !r.validada)),
            )
            .map((r) => ({
              ...r,
              isEditarBtnDisponivel: !r.excluida && this.prazoAtual && !r.consolidada,
              isArquivarBtnDisponivel: !r.excluida && this.prazoAtual && !r.consolidada,
              isDesfazerBtnDisponivel: !r.excluida && this.prazoAtual && r.consolidada,
              isLupaBtnDisponivel: !r.excluida && !this.prazoFuturo && r.consolidada,
              colunasCompetencias: this.gerarColunas(r.competenciasAtuais),
            }));
        default:
          return [];
      }
    },
    selectAllItens() {
      return this.filtros.unidades.length === this.unidades.length;
    },
    selectSomeItens() {
      return this.filtros.unidades.length > 0 && !this.selectAllItens;
    },
    icon() {
      if (this.selectAllItens) {
        return 'check_box';
      }
      if (this.selectSomeItens) {
        return 'indeterminate_check_box';
      }

      return 'check_box_outline_blank';
    },
    prazoAtual() {
      return !this.prazoEsgotado && !this.prazoFuturo;
    },
    prazoEsgotado() {
      return Data.compare('isAfter', { b: this.fimPeriodo });
    },
    prazoFuturo() {
      return Data.compare('isBefore', { b: this.inicioPeriodo });
    },
  },

  watch: {
    'filtros.situacao': function () {
      this.selectedResponsabilidades = [];
    },
    mapeamento() {
      this.responsabilidadesArmazenadas.splice(0);
      this.filtros.unidades = [];
      this.loadResponsabilidades();
    },
  },

  created() {
    this.initialize();
  },

  methods: {
    ...mapActions('app', ['setBreadcrumbs']),
    agruparCompetenciasSelecionadas() {
      competenciaTecnicaRepository
        .agrupar(
          this.nomeCompetenciaAgrupadora.trim(),
          this.competenciasSelecionadas,
          this.mapeamento,
          this.tipoNormalizacao,
        )
        .then(async (res) => {
          const competenciaAgrupadora = res.data;
          const competenciasTecnicasPosAgrupamento = this.competenciasTecnicas.filter(
            (c) => !this.competenciasSelecionadas.some((cs) => cs.id === c.id),
          );
          competenciasTecnicasPosAgrupamento.push(competenciaAgrupadora);
          await this.$store.dispatch('responsabilidade/load', {
            mapeamento: this.mapeamento.id,
            comissao: this.comissao,
          });
          const payload = {
            tipo: 'TECNICA',
            competencias: competenciasTecnicasPosAgrupamento.sort((a, b) => a.nomeAtual.localeCompare(b.nomeAtual)),
          };
          await this.$store.dispatch('competencia/setCompetencias', payload);
          this.competenciasSelecionadas = [];
          this.nomeCompetenciaAgrupadora = '';
          this.toggleAgruparCompetenciasSelecionadas();
          await this.$store.dispatch('app/success', {
            response: res,
            message: 'Competências agrupadas com sucesso!',
          });
        });
    },
    toggleAgruparCompetenciasSelecionadas() {
      this.agruparCompetenciasSelecionadasDialog = !this.agruparCompetenciasSelecionadasDialog;
    },
    initialize() {
      if (this.mapeamento && this.mapeamento.id) {
        this.loadResponsabilidades();
        let tutorial = '';

        switch (this.tipoNormalizacao) {
          case 'normalizacao':
            if (this.comissao) {
              this.tituloPagina = 'Normalização das Competências Técnicas';
              this.inicioPeriodo = this.mapeamento.inicioPerRespCom;
              this.fimPeriodo = this.mapeamento.fimPerRespCom;
              tutorial = 'NormalizacaoResponsabilidade';

              this.situacoes = [
                { id: 'TODAS', descricao: 'Todas' },
                { id: 'ARQUIVADAS', descricao: 'Arquivadas' },
                { id: 'NORMALIZADAS', descricao: 'Normalizadas' },
                { id: 'NAO_NORMALIZADAS', descricao: 'Não Normalizadas' },
              ];

              this.headers = [
                {
                  text: 'RESPONSABILIDADE',
                  value: 'tituloAtual',
                  sortable: false,
                  width: '30%',
                },
                {
                  text: '',
                  value: 'status',
                  sortable: false,
                  width: '10%',
                },
                {
                  text: 'UNIDADE',
                  value: 'unidade.sigla',
                  sortable: false,
                  align: 'start',
                  width: '10%',
                },
                {
                  text: 'COMPETÊNCIAS',
                  value: 'data-table-expand',
                  width: '15%',
                  align: 'center',
                },
                {
                  text: '',
                  value: 'tipo',
                  sortable: false,
                  width: '10%',
                },
                {
                  text: '',
                  value: 'acoes',
                  sortable: false,
                  width: '25%',
                  align: 'center',
                },
              ];
            } else {
              this.$router.push('/403');
            }
            break;
          case 'consolidacao':
            if (this.comissao) {
              this.tituloPagina = 'Consolidação das Competências Técnicas';
              this.inicioPeriodo = this.mapeamento.inicioPerRespConsol;
              this.fimPeriodo = this.mapeamento.fimPerRespConsol;
              tutorial = 'ConsolidacaoResponsabilidade';

              this.situacoes = [
                { id: 'TODAS', descricao: 'Todas' },
                { id: 'ARQUIVADAS', descricao: 'Arquivadas' },
                { id: 'CONSOLIDADAS', descricao: 'Consolidadas' },
                { id: 'NAO_CONSOLIDADAS', descricao: 'Não Consolidadas' },
                { id: 'VALIDADAS', descricao: 'Validadas' },
                { id: 'NAO_VALIDADAS', descricao: 'Não Validadas' },
              ];

              this.headers = [
                {
                  text: 'RESPONSABILIDADE',
                  value: 'tituloAtual',
                  sortable: false,
                  width: '30%',
                },
                {
                  text: '',
                  value: 'status',
                  sortable: false,
                  width: '10%',
                },
                {
                  text: 'UNIDADE',
                  value: 'unidade.sigla',
                  sortable: false,
                  width: '10%',
                  align: 'start',
                },
                {
                  text: 'COMPETÊNCIAS',
                  value: 'data-table-expand',
                  width: '15%',
                  align: 'center',
                },
                {
                  text: '',
                  value: 'tipo',
                  sortable: false,
                  width: '10%',
                },
                {
                  text: '',
                  value: 'acoes',
                  sortable: false,
                  width: '25%',
                  align: 'center',
                },
              ];
            } else {
              this.$router.push('/403');
            }
            break;
          default:
            this.$router.push('/404');
        }

        if (!this.isTutorialExibido && tutorial.trim()) {
          this.$store.dispatch('app/showTutorial', { nome: tutorial });
        }
      } else {
        this.$router.push('/403');
      }
    },
    loadResponsabilidades() {
      this.getPeriodo();
      if (this.responsabilidadesArmazenadas.length === 0 && (this.prazoAtual || this.prazoEsgotado)) {
        const payload = { mapeamento: this.mapeamento.id, comissao: true };
        this.$store.dispatch('responsabilidade/load', payload);
      }
    },
    getPeriodo() {
      switch (this.tipoNormalizacao) {
        case 'normalizacao':
          this.inicioPeriodo = this.mapeamento.inicioPerRespCom;
          this.fimPeriodo = this.mapeamento.fimPerRespCom;
          break;
        case 'consolidacao':
          this.inicioPeriodo = this.mapeamento.inicioPerRespConsol;
          this.fimPeriodo = this.mapeamento.fimPerRespConsol;
          break;
        default:
          break;
      }
    },
    async isUpdated(response, mensagem = 'Responsabilidade editada com sucesso!') {
      const responsabilidade = response.data;

      if (responsabilidade && responsabilidade.id) {
        this.dialogs.dialogEdit.item = responsabilidade;
        const index = this.responsabilidadesArmazenadas.findIndex((r) => r.id === responsabilidade.id);
        if (index !== -1) {
          this.responsabilidadesArmazenadas.splice(index, 1, responsabilidade);
          await this.$store.dispatch('app/success', { response, message: mensagem });
        }
      }
    },
    editItem(item) {
      this.dialogs.dialogEdit.item = item;
      this.toggleEditarResponsabilidade();
    },
    visualizarItem(item) {
      this.dialogs.dialogHistorico.item = item;
      this.toggleHistoricoResponsabilidade();
    },
    consolidar() {
      const responsabilidades = this.selectedResponsabilidades.map((r) => r.id);
      const operacao = (this.tipoNormalizacao === 'consolidacao' && responsabilidadeRepository.consolidar)
        || (this.tipoNormalizacao === 'normalizacao' && responsabilidadeRepository.normalizar);
      const resultadoStr = (this.tipoNormalizacao === 'consolidacao' && 'consolidada')
        || (this.tipoNormalizacao === 'normalizacao' && 'normalizada');

      operacao(responsabilidades).then((res) => {
        const responsabilidadesConsolidadas = res.data;
        if (responsabilidadesConsolidadas.length > 0) {
          responsabilidadesConsolidadas.forEach((responsabilidade) => {
            const index = this.responsabilidadesArmazenadas.findIndex((r) => r.id === responsabilidade.id);
            if (index !== -1) {
              this.responsabilidadesArmazenadas.splice(index, 1, responsabilidade);
              this.$store.dispatch('app/success', {
                response: res,
                message: `Responsabilidade(s) ${resultadoStr}(s) com sucesso!`,
              });
            }
          });
          this.selectedResponsabilidades = [];
        }
      });
    },
    desfazer(item) {
      const operacao = (this.tipoNormalizacao === 'consolidacao' && responsabilidadeRepository.desconsolidar)
        || (this.tipoNormalizacao === 'normalizacao' && responsabilidadeRepository.desnormalizar);
      const acao = (this.tipoNormalizacao === 'normalizacao' && 'Normalização')
        || (this.tipoNormalizacao === 'consolidacao' && 'Consolidação');

      operacao(item.id).then(async (res) => {
        await this.isUpdated(res, `${acao} cancelada com sucesso!`);
      });
    },
    confirmDeleteItem(item) {
      this.dialogs.dialogRemove.item = item;
      this.dialogs.dialogRemove.visible = true;
    },
    deleteItem() {
      responsabilidadeRepository.setExcluida(this.dialogs.dialogRemove.item.id).then(async (res) => {
        await this.isUpdated(res, 'Responsabilidade arquivada com sucesso!');
        this.toggleDialogRemove();
      });
    },
    restaurarItem(item) {
      responsabilidadeRepository.restaurar(item.id).then(async (res) => {
        await this.isUpdated(res, 'Responsabilidade restaurada com sucesso!');
      });
    },
    getUnidadeSiglaAndNome(item) {
      return `${item.sigla} - ${item.nome}`;
    },
    removeUnidade(item) {
      const index = this.filtros.unidades.findIndex((u) => u.id === item.id);
      if (index !== -1) {
        this.filtros.unidades.splice(index, 1);
      }
    },
    toggleDialogRemove() {
      this.dialogs.dialogRemove.visible = !this.dialogs.dialogRemove.visible;
      this.dialogs.dialogRemove.item = '';
    },
    toggleDialogAgradecimento() {
      this.dialogs.dialogAgradecimento.visible = !this.dialogs.dialogAgradecimento.visible;
    },
    toggleEditarResponsabilidade() {
      this.dialogs.dialogEdit.visibilidade = !this.dialogs.dialogEdit.visibilidade;
    },
    toggleHistoricoResponsabilidade() {
      this.dialogs.dialogHistorico.visibilidade = !this.dialogs.dialogHistorico.visibilidade;

      if (!this.dialogs.dialogHistorico.visibilidade) {
        this.dialogs.dialogHistorico.item = null;
      }
    },
    toggleAllCheckboxes() {
      if (this.selectedResponsabilidades.length) {
        this.selectedResponsabilidades = [];
      } else if (this.tipoNormalizacao === 'consolidacao') {
        this.selectedResponsabilidades = this.responsabilidades.filter((r) => !r.consolidada && !r.excluida);
      } else if (this.tipoNormalizacao === 'normalizacao') {
        this.selectedResponsabilidades = this.responsabilidades.filter((r) => !r.normalizada && !r.excluida);
      }
    },
    toggleItens() {
      this.$nextTick(() => {
        if (this.selectAllItens) {
          this.filtros.unidades = [];
          this.loadResponsabilidades();
        } else {
          this.filtros.unidades = [...this.unidades];
          this.loadResponsabilidades();
        }
      });
    },
    gerarColunas(itens) {
      const columns = {
        id: '',
        lista: [],
      };
      const mid = Math.ceil(itens.length / 3);

      for (let col = 0; col < mid; col += 1) {
        columns.id = col;
        columns.lista.push(itens.slice(col * 3, col * 3 + 3));
      }

      return columns;
    },
    generateWorksheet() {
      const documento = {
        titulo: 'responsabilidades',
        planilhas: [
          {
            titulo: 'Responsabilidades',
            colunas: [
              { header: 'RESPONSABILIDADE', key: 'responsabilidade', width: 50 },
              { header: 'SITUAÇÃO', key: 'situacao', width: 15 },
              { header: 'UNIDADE', key: 'unidade', width: 15 },
              { header: 'COMPETÊNCIAS', key: 'competencias', width: 40 },
              { header: 'DIFICULDADE', key: 'dificuldade', width: 15 },
              { header: 'IMPACTO', key: 'impacto', width: 15 },
            ],
            dados: this.responsabilidades.map((r) => {
              let situacao = '';

              if (r.excluida) {
                situacao = '[Arquivada] ';
              }

              if (this.tipoNormalizacao === 'consolidacao' && r.consolidada) {
                situacao += 'Consolidada';
              } else if (this.tipoNormalizacao === 'consolidacao' && r.validada) {
                situacao += 'Validada';
              } else if (r.normalizada) {
                situacao += 'Normalizada';
              }

              return {
                responsabilidade: r.tituloAtual,
                situacao,
                unidade: r.unidade.sigla,
                competencias: `${r.competenciasAtuais.map((c) => c.nomeAtual).join(', ')}`,
                dificuldade: r.dificuldadeAtual.valor,
                impacto: r.impactoAtual.valor,
              };
            }),
          },
        ],
      };

      generateXLS(documento);
    },
  },
};
</script>
